import React from 'react'
import {Link, withRouter} from 'react-router'
import root from '../shared/utils'

const Navbar = React.createClass({
  getInitialState: function() {
    return {
      navClass: 'navbar-collapse'
    }
  },
  collapseNavbar: function () {
    this.setState({navClass: 'navbar-collapse'})
  },
  openNavbar: function () {
    this.setState({navClass: 'navbar-collapse navbar-collapse-show'})
  },
  logout: function() {
    document.cookie = "addressId=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    document.cookie = "optOutOfBeta=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

  },
  render: function () {
    let logoutPath = root + '/logout'

    let navbarClassNames = 'navbar navbar-inverse olive-green-background'

    let navbarListItems = [
      <Link activeClassName='active' to='/dashboard'><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/star.png'} style={{marginLeft:'10px'}} alt=''/>Dashboard</Link>,
      <Link activeClassName='active' to='/history'><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/time44.png'} style={{marginLeft:'10px'}} alt=''/>History</Link>,
      <Link activeClassName='active' to='/schedule'><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/calendar.png'} style={{marginLeft:'10px'}} alt=''/>Calendar</Link>,
      <Link activeClassName='active' to='/account'><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/my-tasks.png'} style={{marginLeft:'10px'}} alt=''/>My Account</Link>,
      <Link activeClassName='active' to='/billing'><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/billing.png'} style={{marginLeft:'10px'}} alt=''/>Billing</Link>,
      <Link activeClassName='active' to='/support'><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/question30.png'} style={{marginLeft:'10px'}} alt=''/>Support</Link>,
      <a href={logoutPath} onClick={this.logout} style={{paddingRight: '30px', textDecoration: 'none'}}><img className='visible-xs pull-left nav-icon' src={'/common/latest/images/consumer/nav-drawer/signout.png'} style={{marginLeft:'10px'}} alt=''/>Logout</a>,
      <a onClick={this.props.optOut} style={{paddingRight: '30px', textDecoration: 'none'}}><i style={{color: 'rgb(130,130,130)', fontSize: 18, marginLeft:'10px'}} className="fa fa-arrow-left nav-icon"></i>Back to old Dashboard</a>,
    ]

    let currentRoute = {}

    currentRoute = this.props.routes[this.props.routes.length - 1]
    let navNodes = navbarListItems.map(function (node, i) {
      if (node.props.to === ('/' + currentRoute.path) || (node.props.to === '/dashboard' && !currentRoute.path)) {
        return (
          <li className='active' key={i}>{node}</li>
        )
      } 
      else if(!node.props.to) {
        return (
          <li className='visible-xs' key={i}>{node}</li>
        )
      }
      else {
        return (
          <li key={i}>{node}</li>
        )
      }
    })
    return (
      <nav className={navbarClassNames}>
          <div className='navbar-header'>
            <button type='button' className='navbar-toggle collapsed btn-sm' data-target='#navbar' aria-expanded='false' onClick={this.openNavbar}>
              <span className='sr-only'>Toggle navigation</span>
              <span className='icon-bar' />
              <span className='icon-bar' />
              <span className='icon-bar' />
            </button>
          </div>
          <nav className={this.state.navClass} id='navbar'>
            <ul className='nav navbar-nav' onClick={this.collapseNavbar}>
              {navNodes}
            </ul>
          </nav>
      </nav>
    )
  }
})

Navbar.propTypes = {
  routes: React.PropTypes.oneOfType([
    React.PropTypes.array,
    React.PropTypes.object
  ]).isRequired
}

Navbar.defaultProps = {
  routes: [
    {path: null}
  ]
}
export default withRouter(Navbar)



// WEBPACK FOOTER //
// ./src/components/shared/navbar.jsx